<template>
	<div>
		<div class="">
			<div v-if="showTitle" class="col-md-12 px-0 mb-1 d-flex align-items-center justify-content-center">
				<div>
					<h5>{{ tabLabel }}</h5>
				</div>
				<div class="ml-auto">
					
					<el-checkbox border size="small" class="me-2" v-model="showchart" v-if="false">
						Show Chart
					</el-checkbox>
					
					<el-popover trigger="click" size="small" ref="dropdown" v-model="dropdownVisible" popper-class="dropdown-filter">
						<el-button slot="reference" type="primary" plain size="small">
							<i class="fa fa-filter"></i> &nbsp; Filter
						</el-button>
						<div>
							<div class="ps-3 pe-3 pt-1 pb-1">
								<h5><i class="fa fa-filter"></i> &nbsp; Filter {{ tabLabel }}</h5>
							</div>
							<el-divider class="m-0"></el-divider>
							<div class="dropdown-filter-form">
								<el-form label-position="top" label-width="100px">
									<div class="row">
										<div class="col-md-6">
											<el-form-item label="Station:">
												<el-select v-model="stationid" clearable filterable placeholder="Select" size="medium" style="width:100%;">
													<el-option v-for="item3 in spbu.list" :key="item3.StationId" :label="item3.StationName" :value="item3.StationId">
													</el-option>
												</el-select>
											</el-form-item>
										</div>
										<div class="col-md-6">
											<el-form-item label="Date:">
												<div class="block">
													<el-date-picker
													v-model="dateRange"
													type="daterange"
													align="right"
													unlink-panels
													range-separator="-"
													start-placeholder="Start date"
													end-placeholder="End date"
													format="yyyy-MM-dd"
													value-format="yyyy-MM-dd"
													:picker-options="pickerOptions">
													</el-date-picker>
												</div>
											</el-form-item>
										</div>
									</div>

									<div class="row" v-if="false">
										<div class="col-md-6">
											<el-form-item label="Area:">
												<el-radio-group v-model="area" size="small">
													<el-radio-button :label="item2.value" v-for="(item2, index2) in options.area" :key="item2.value+'_'+index2" style="margin-left:0px;">{{item2.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
										</div>

										<div class="col-md-6">
											<el-form-item label="Owner:">
												<el-radio-group v-model="owner" size="small">
													<el-radio-button :label="item2.value" v-for="(item2, index2) in options.owner" :key="item2.value+'_'+index2" style="margin-left:0px;">{{item2.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
										</div>
									</div>								
									
								</el-form>
							</div>
							<el-divider class="m-0"></el-divider>
							<div class="py-2 px-4">
								<div class="row">
									<div class="col-md-12 d-flex align-items-center">
										<div class="ml-auto">
											<el-button type="danger" size="medium" @click="closeDropdownForm" style="min-width:100px;"><i class="fa fa-close"></i> &nbsp; Close</el-button>
											<el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="min-width:100px;"><i class="fa fa-check"></i> &nbsp; Apply Filter</el-button>
										</div>										
									</div>
								</div>
							</div>
						</div>
					</el-popover>

					<el-button class="ms-2" type="success" plain size="small" @click="exportExcel()" v-if="reportdata?.data?.length">
						<i class="fa fa-file-excel"></i> &nbsp; Export
					</el-button>
					<vue-excel-xlsx 
						v-show="false"
						ref="excelExport"
						:data="dataXLSX(reportdata)"
						:columns="columnXLSX(reportdata)"
						:file-name="'Maintenance Report ' + tabLabel"
						:file-type="'xlsx'"
						:sheet-name="'sheet1'"
						>
						<i class="far fa-file-excel"></i>
					</vue-excel-xlsx>
					
				</div>
			</div>

			<div class="mb-3" v-if="false">          
				<el-collapse>
					<el-collapse-item>
						<template slot="title">
							<span style="color:#606266;font-size:14px;"><i class="header-icon el-icon-search"></i>&nbsp;&nbsp;&nbsp;Filter</span>
						</template>
						<el-form label-position="top" label-width="100px">
							<div class="row">
								<div class="col-md-6">
									<el-form-item label="Station:">
										<el-select v-model="stationid" clearable filterable placeholder="Select" size="medium" style="width:100%;">
											<el-option v-for="item3 in spbu.list" :key="item3.StationId" :label="item3.StationName" :value="item3.StationId">
											</el-option>
										</el-select>
									</el-form-item>
								</div>
								<div class="col-md-6">
									<el-form-item label="Date:">
										<div class="block">
											<el-date-picker
											v-model="dateRange"
											type="daterange"
											align="right"
											unlink-panels
											range-separator="-"
											start-placeholder="Start date"
											end-placeholder="End date"
											format="yyyy-MM-dd"
											value-format="yyyy-MM-dd"
											:picker-options="pickerOptions">
											</el-date-picker>
										</div>
									</el-form-item>
								</div>
							</div>

							<div class="row" v-if="false">
								<div class="col-md-6">
									<el-form-item label="Area:">
										<el-radio-group v-model="area" size="small">
											<el-radio-button :label="item2.value" v-for="(item2, index2) in options.area" :key="item2.value+'_'+index2" style="margin-left:0px;">{{item2.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>

								<div class="col-md-6">
									<el-form-item label="Owner:">
										<el-radio-group v-model="owner" size="small">
											<el-radio-button :label="item2.value" v-for="(item2, index2) in options.owner" :key="item2.value+'_'+index2" style="margin-left:0px;">{{item2.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>

							</div>								
							

							<div class="row">
								<div class="col-md-6">
									<el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply Filter</el-button>
								</div>
							</div>
						</el-form>
					</el-collapse-item>
				</el-collapse>
			</div>

			<div class="row" v-if="false">
				<div class="col-md-3 mb-3">
					<el-checkbox v-model="showchart">Show Chart</el-checkbox>
				</div>
				<div class="col-md-8 mb-3" v-if="showchart">
					<el-radio-group v-model="charttype">
						<el-radio label="piechart" size="small">Pie Chart</el-radio>
						<el-radio label="barchart" size="small">Bar Chart</el-radio>
						<el-radio label="linechart" size="small">Line Chart</el-radio>
					</el-radio-group>
				</div>
				
			</div>
			<div class="mb-0" >
				<PieChart v-loading.body="loading.chart" :data="piechartdata" :url="''" :height="380" style="width:380px;" v-if="showchart && charttype=='piechart'" />
				<BarChart v-loading.body="loading.chart" :data="chartdata" :width="500" :height="380" v-if="showchart && charttype=='barchart'" />
				<LineChart v-loading.body="loading.chart" :data="chartdata" :width="500" :height="192" v-if="showchart && charttype=='linechart'" style="margin-top:20px;"/>
			</div>

			<div class="mt-2">
				<ReportResultTable :reportname="'MaintenanceReport'" :reportdata="reportdata" :loading="loading.table" :reporturl="urlRequestParams" :issuccess="loading.isSuccess" style="width:100%;"/> 
			</div>
		</div>
	</div>
</template>

<script>

import Maintenance from '@/components/page/Maintenance.js'
import ReportParamSelect from '@/views/pages/ReportParamSelect.vue'
import ReportResultTable from '@/views/pages/ReportResultTable2Custom.vue'
import { Rainbow, FuelColor, AxiosWithJar, Config} from '@/utility.js'
import Loader from '@/components/loader/Loader.vue'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'
import PieChart from '@/components/chart/Pie.js'

//import * as ChartGeo from 'chartjs-chart-geo'

export default
{
	extends: Maintenance,
	props: ['tabIndex','tabName', 'tabLabel', 'showTitle'],
	components: { 
		//ReportParamSelect,
		ReportResultTable,
		LineChart,
		BarChart,
		PieChart,
		//Loader,
	},

	data(){
		return {
			options: {
				detail1:[
					{ value: "", name: "ALL" }, 
					{ value: "station", name: "BY STATION" }, 
				],
				detail2:[
					{ value: "", name: "ALL" }, 
					{ value: "group", name: "BY GROUP", field: "ProductGroup" }, 
					{ value: "product", name: "BY PRODUCT", field: "ProductName" },
				],
				detail:[
					{ value: "", name: "Detail Per Station" }, 
					{ value: "area", name: "Rekap Per Area" }, 
					{ value: "type", name: "Rekap Per Type" }, 
					{ value: "area_type", name: "Rekap Per Type Per Area" }, 
					{ value: "hose", name: "Rekap Nozzle" }, 
					{ value: "area_hose", name: "Rekap Nozzle Per Area" }, 
					{ value: "station_hose", name: "Rekap Nozzle Per Station" }, 
					{ value: "pos", name: "Detail Pos" }, 
				],
				type:[
					{ value: "", name: "ALL" }, 
					{ value: "SPBU", name: "SPBU" }, 
					{ value: "SPBU-T", name: "SPBU-T" }, 
					{ value: "MODULAR", name: "MODULAR" }, 
					{ value: "PERTASHOP", name: "PERTASHOP" }, 
					{ value: "SHELTER", name: "SHELTER" }, 
					{ value: "SPBG", name: "SPBG" }, 
				],
				owner:[
					{ value: "", name: "ALL" }, 
					{ value: "COCO", name: "COCO" }, 
					{ value: "CODO", name: "CODO" }, 
					{ value: "KSO", name: "KSO" }, 
					{ value: "TAC", name: "TAC" }, 
				],
				presentation:[
					{ value: "1", name: "Table" }, 
					{ value: "9", name: "Chart" }, 
					{ value: "8", name: "Map" }, 
				],
				area:[
					{ value: "", name: "ALL" }, 
					//{ value: "area", name: "BY AREA", field: "SalesArea" }, 
					{ value: "1", name: "1" }, 
					{ value: "2", name: "2" }, 
					{ value: "3", name: "3" }, 
					{ value: "4", name: "4" }, 
					{ value: "5", name: "5" }, 
				],
				update:[
					{ value: "", name: "ALL" }, 
					{ value: "1", name: "UPDATE" }, 
					{ value: "0", name: "NOT UPDATE" }, 
				],
				status:[
					{ value: "", name: "ALL" }, 
					{ value: "ONLINE", name: "ONLINE" }, 
					{ value: "OFFLINE", name: "OFFLINE" }, 
				],
			},

			loading: {
				table: false,
				chart: false,
				isSuccess: false,
			},

			dateRange: '',
			type: '',
			presentation:'1',
			detail:'',
			owner:'',
			city:'',
			
			charttype: 'linechart', //barchart //linechart
			showchart: false,
			stationList: [],
			//tabIndex: this.$route.query.tab ? this.$route.query.tab : 0, 
			reportdata: [],
			chartdata: [],
			piechartdata: [],
			showchartupdate: false,
			showchartstoreupdate: false,
			stacked: true,
			stationid: this.$route.query.station ? this.$route.query.station : '',
			area: this.$route.query.area ? this.$route.query.area : '',
			status: this.$route.query.status ? this.$route.query.status : '',
            update: this.$route.query.update ? this.$route.query.update : '',
			urlRequestParams: '',

			pickerOptions: {
				shortcuts: [{
					text: 'Last week',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last month',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last 3 months',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
					picker.$emit('pick', [start, end]);
					}
				}]
			},

			is2024OrBelow: false,
			is2025OrAbove: true,
			dropdownVisible: false,

		}
	},
	watch:
	{
		//area() { this.resumePilihan() },
		//status(){ this.resumePilihan() },

	}, 
    mounted()
    {
        this.$emit('childrenRoute');
		this.loadStationList() 
		//this.resumePilihan()
		//this.getChart()

		//this.loadMap()
    },
    methods:{
		floatingSearchForm(){
			document.querySelector('.search.form').classList.toggle('floating')            
		},
		searchFilterButtonClick(){
			document.querySelector('li.filter').classList.toggle('down')
			var select=document.querySelectorAll('.search.form')
			Array.from(select).map((e)=>{e.classList.toggle('minimize')})
		},

		async resumePilihan() {
			this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/maintenance/pinsyst-last-update?'
	
			//this.urlRequestParams+='&startDate='+ this.dateRange[0]
			//this.urlRequestParams+='&endDate='+ this.dateRange[1]
			this.urlRequestParams+='&date-range-start='+(this.dateRange ? this.dateRange[0] : '')
			this.urlRequestParams+='&date-range-end='+(this.dateRange ? this.dateRange[1] : '')
			this.urlRequestParams+='&station='+this.stationid
			/*
			this.urlRequestParams+='&city='+this.city
			this.urlRequestParams+='&area='+this.area
			this.urlRequestParams+='&type='+this.type
            this.urlRequestParams+='&owner='+this.owner
			this.urlRequestParams+='&presentation='+this.presentation
			this.urlRequestParams+='&detail='+this.detail
			*/

			this.loading.table = true
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.reportdata = response.data;
					this.loading.isSuccess = true;
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.table = false;
				})
        },

		async getChart() {
			this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/v1/maintenance/outletchart?'
	
			this.urlRequestParams+='&startDate='+ this.dateRange[0]
			this.urlRequestParams+='&endDate='+ this.dateRange[1]
			//this.urlRequestParams+='&date-range-start='+this.date.Start
			//this.urlRequestParams+='&date-range-end='+this.date.End
			//this.urlRequestParams+='&station='+this.stationid
			this.urlRequestParams+='&city='+this.city
			this.urlRequestParams+='&area='+this.area
			this.urlRequestParams+='&type='+this.type
            this.urlRequestParams+='&owner='+this.owner
			this.urlRequestParams+='&presentation='+this.presentation
			this.urlRequestParams+='&detail='+this.detail

			this.loading.chart = true;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					//this.reportdata = response.data;

					let legend = "legend";
					let label = "StationType";
					let valuecol = "Cnt";
					let prefix = "";
											
					this.chartdata = this.processBarChart(response.data.data, legend, prefix, valuecol, false, label, "", 1, 2, Rainbow, false, false, false);

					this.loadPieChart(response.data.data)

				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.chart = false;
				})
        },

		refreshChart() {
			let opt = this.getoption(this.detail2, this.options.detail2)
			let a = opt && opt.field ? opt.field : ""
			
			opt = this.getoption(this.area, this.options.area)
			a = opt && opt.field ? opt.field : a
			
			let b = "Period"
			let c = (a == "ProductName") ? FuelColor : Rainbow
			
			this.chartdata = this.processBarChart(this.reportdata.data, a, "", "SalesVolume", false, b, "", 1000, 2, c, false, false, false, this.stacked);
		},

		loadPieChart(items) {
			var warna = []

            let value = [];
            let idx = 0;
            for (var row in items) {
                //add color
                warna[items[row].StationType] = Rainbow[idx];//'#FFB22E'

                //add value
                let main = {
                    transtype: items[row].StationType, 
                    amount: items[row].Cnt,
                };

                value.push(main);
                idx++;
            }

			this.piechartdata = this.processPieChart(value, "amount", "transtype", 1, 2, warna); 
            //return this.processPieChart(value, "amount", "transtype", 1, 2, warna); 
		},

		loadMap() {
		
		},

		applyFilter() {
			this.dropdownVisible = false; 
			//filter
			this.resumePilihan()
			this.getChart()
			//this.getBaselineComparison()
			//this.getBaselineChartSelfServiceSales()
        },

		exportExcel() {
			this.$refs["excelExport"].exportExcel();
			//console.log('export excel');
		},

		closeDropdownForm() {
			this.dropdownVisible = false; 
		},

    },
    computed: {	

    }
}
</script>
<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>